import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

export const helpers = createMultiStyleConfigHelpers([
  'container',
  'wrapper',
  'banner',
  'message',
  'icon',
  'crossIcon',
  'messageWrapper',
])
export const StickyBanner = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      position: 'sticky',
      top: 0,
      zIndex: { base: 500, lg: 'sticky' },
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      padding: 3.5,
    },
    banner: {
      position: 'relative',
      display: 'flex',
      padding: 0,
      gap: '1rem',
      width: 'full',
    },
    messageWrapper: {
      display: 'flex',
      flex: '1',
      gap: '4',
    },
    message: {
      textAlign: { base: 'left', lg: 'center' },
      mr: { base: 4, md: 'unset' },
      maxW: { base: 'unset', md: '80%' },
    },
    crossIcon: {
      position: 'relative',
      cursor: 'pointer',
    },
  },
  variants: {
    PROMOTION: {
      messageWrapper: {
        justifyContent: 'center',
      },
    },
  },
})
